function broadcast(componentName, eventName, params) {
  this.$children.forEach(child => {
    let name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    }
    if (child.$children.length) {
      broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}

import { mapGetters, mapState } from 'vuex';
import * as types from '../store/mutation-types';
// import request from '@/axios/request';
import { doGet, doPost } from '@/axios/http';
import {formatDate} from 'element-ui/src/utils/date-util';
import { addClass, removeClass } from 'element-ui/src/utils/dom';
import { getAbsPoint, isWeixin, isMobile, randomGenerate } from 'jyutils/utils';
import fileDownload from 'js-file-download';
import NodeRSA from 'node-rsa';
import CryptoJS  from 'crypto-js';
export default {
  data() {
    return {
      editData: {},
      originData: '',
      leaveData: ''
    }
  },
  computed: {
    ...mapGetters({
      publickey: 'publickey',
      settings: 'settings',
      sexMap: [types.BASE_LOAD.sexMap],
      xiaoquMap: [types.BASE_LOAD.xiaoquMap],
    }),
    userSettings() {
      let settings = this.userinfo.settings;
      return settings ? JSON.parse(settings) : {};
    },
    rootPath() {
      // return this.$axios.defaults.baseURL +'/';
      return process.env.VUE_APP_API;
      // return '/api/';
    },
    myHost() {
      let href = location.href;
      let pathname = location.pathname;
      if (pathname == '/') {
        return href;
      }
      return href.substring(0, pathname.length ? href.indexOf(pathname) : href.length) + '/';
    },
    myPath() {
      if (process.env.NODE_ENV === 'production') {
        return this.myHost + 'api/';
      }
      let devurl = this.baseUrl_dev;
      if (devurl && !devurl.endsWith('/')) {
        devurl += '/';
      }
      return devurl;
    },
    wsHost() {
      let host = this.myHost;
      // console.log('host', host, location.pathname)
      if (host.startsWith('https')) {
        return 'wss' + host.substring(5);
      } else {
        return 'ws' + host.substring(4);
      }
    },
    assetsPath() {
      return process.env.NODE_ENV === 'production' ? process.env.VUE_APP_ASSETPATH_PRD : process.env.VUE_APP_ASSETPATH_DEV;
    },
    BASEPATH() {
      return process.env.NODE_ENV === 'production' ? 'http://'+ location.host : 'http://'+ location.host;
    },
    sitetitle() {
      return this.apptitle || process.env.VUE_APP_TITLE || '管理系统';
    },
    sitelogo() {
      return this.assetsPath +'static/images/'+ (process.env.VUE_APP_LOGO || 'logo.jpg');
    },
    wxname() {
      return process.env.VUE_APP_WEIXIN_NAME || '管理系统';
    },
    finishedtext() {
      return process.env.VUE_APP_LOAD_FINISH || '管理系统';
    },
    userinfo() {
      return this.$store.getters.userinfo;
    },
    member() {
      return this.$store.getters.member;
    },
    settingvue() {
      return this.$store.getters.settingvue;
    },
    isSm() {
      return this.$store.state.isSm;
    },
    issys() {
      return this.userinfo.type == 1;
    },
    isSuper() {
      return this.userinfo.id === 'super';
    },
    units() {
      return this.userinfo.unitList;
    },
    allUnitList() {
      return this.userinfo.allUnitList;
    },
    roletags() {
      let tags = this.userinfo.roletags ? this.userinfo.roletags.split(',') : [];
      return Array.from(new Set(tags));
    },
    weeks() {
      return ['一','二','三','四','五','六','日']
    },
    getRandom() {
      return parseInt(1000000 * Math.random());
    },
    uploadPic() {
      return 'sys/utils/uploadPic'; // this.rootPath +
    },
    uploadPicData() {
      return {w: 1000};
    },
    headers() {
      return {Authorization: this.$store.getters.token || '', mtoken: this.$store.getters.mtoken || ''};
    },
    noimg() {
      return this.assetsPath + 'static/images/noimg.jpg';
    },
    isWeixin() {
      return isWeixin();
    },
    isMobile() {
      return isMobile();
    },
    // 需要保存
    needsave() {
      return JSON.stringify(this.editData) != this.originData;
    },
    // 列表分页layout
    pageLayout() {
      return this.isSm ? 'total, prev, next' : 'total, sizes, prev, pager, next, jumper';
    },
    // 全角空格
    space2() {
      // eslint-disable-next-line
      return '　';
    },
    // 抽屉宽度
    drawerWidth() {
      let w = document.body.offsetWidth;
      let scale = (300 / w) * 100;
      if (scale > 100) {
        scale = 100;
      }
      if (scale < 30) {
        scale = 30;
      }
      return scale + '%';
    },
    // 禁用的学籍字段
    rolldisablefields() {
      let fields = this.settings.rolldisablefields || '';
      return fields.split(',');
    },
    // 启用前置条件
    ifPrecondition() {
      return this.settings.ifprecondition ? true : false;
    },
    // 缴费渠道
    feeways() {
      return ['高校', '学习中心', '未知'];
    },
    // 启用登记提交缴费
    ifRegisterfee() {
      return this.settings.ifregisterfee ? true : false;
    }
  },
  methods: {
    getParent(componentName) {
      if (!componentName) {
        return undefined
      }
      let parent = this.$parent || this.$root;
      let name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }

      return parent;
    },
    dispatch(componentName, eventName, params) {
      let parent = this.getParent(componentName);
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast(componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params);
    },
    timeout() {
      this.dispatch('index', 'timeout');
    },
    doLogout() {
      this.dispatch('index', 'logout');
    },
    doLogin(backUrl = '') {
      // console.log('login')
      if (backUrl != null && !backUrl) {
        backUrl = this.$route.path;
      }
      this.dispatch('index', 'login', {backUrl: backUrl});
    },
    initUI() {
      let pagebody = window.document.getElementsByClassName('jy-pageBody'), pagefooter = window.document.getElementsByClassName('jy-pageFooter');
      // , nav = window.document.getElementById('jy-breadcrumb');
      if (pagebody && pagebody[0]) {
        pagebody = pagebody[0];
        if (pagefooter) {
          pagefooter = pagefooter[0];
        }
        setTimeout(() => {
          if (pagebody.scrollHeight > pagebody.offsetHeight) {
            //nav.style.width = 'calc(100% - 17px)';
            //pagefooter && (pagefooter.style.right = '17px');
          } else {
            //nav.style.width = '100%';
            //pagefooter && (pagefooter.style.right = '0');
          }
        }, 400);
      }
    },
    isSfzh(value) {
      let sfzReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!value || value.trim().length != 18 || !sfzReg.test(value)) {
        return false;
      }
      return true;
    },
    // 同步编辑器内容
    syncEditor() {
      this.broadcast('JyEditor', 'jy.editor.sync');
    },
    // 验证提交form
    submitform(_form = 'editForm', scrollTo = true) {
      this.syncEditor();
      let form = this.$refs[_form];
      if (!form) {
        this.$message('提交form的ref不正确！');
        return;
      }
      let promise = new window.Promise((resolve, reject) => {
        form.validate((valid, fields) => {
          if (valid) {
            resolve(valid);
          } else {
            reject(fields);
            if (scrollTo) {
              let el = Object.keys(fields)[0];
              let dom = this.$refs['form.'+ el];
              if (Array.isArray(dom)) {
                dom = dom[0];
              }
              if (dom) {
                dom.$el.scrollIntoView({
                  block: 'center',
                  behavior: 'smooth'
                });
              }
            }
          }
        });
      });

      return promise;
    },
    uploadCb(response, options) {
      let json = JSON.parse(response);
      console.log(json)
      if (json && json[types.KEY_STATUS]) {
        if (json[types.KEY_STATUS] >= 200) {
          if (json[types.KEY_STATUS] === types.CODE_SUCCESS) {
            options.okcb && (options.okcb.call(this, json.obj));
            options.cb && (options.cb.call(this, json));
          } else {
            options.cb && (options.cb.call(this, json));
            options.errcb && (options.errcb.call(this, json));
          }
        } else {
          options.cb && (options.cb.call(this, json));
        }
      } else {
        options.cb && (options.cb.call(this, json));
      }
    },
    uploadCb4Axios(response, options) {
      let json = response.data;
      if (json && json[types.KEY_STATUS]) {
        if (json[types.KEY_STATUS] >= 200) {
          if (json[types.KEY_STATUS] === types.CODE_SUCCESS) {
            options.okcb && (options.okcb.call(this, json.obj));
            options.cb && (options.cb.call(this, json));
          } else {
            options.cb && (options.cb.call(this, json));
            options.errcb && (options.errcb.call(this, json));
          }
        } else {
          options.cb && (options.cb.call(this, json));
          options.errcb && (options.errcb.call(this, json));
        }
      } else {
        options.cb && (options.cb.call(this, json));
        options.errcb && (options.errcb.call(this, json));
      }
    },
    initAesKey(data) {
      // 生成AES密钥及向量
      const keyStr = randomGenerate(16);
      const ivStr = randomGenerate(16);

      // ⽣成AES 密钥和向量
      let key = CryptoJS.enc.Utf8.parse(keyStr); // AES密钥
      let iv = CryptoJS.enc.Utf8.parse(ivStr); // AES向量

      // 加密提交内容
      let encry = null;
      if (data) {
        encry = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(JSON.stringify(data)), // 加密提交内容
          key, // AES密钥
          {
            iv: iv, // AES向量
            mode: CryptoJS.mode.CBC, // 指定CBC模式
            padding: CryptoJS.pad.Pkcs7 // 指定pkcs7填充模式
          }
        );
      }

      // console.log('publickey', this.publickey)
      // 加密AES密钥及向量
      const pubKey = new NodeRSA(this.publickey, 'pkcs8-public');
      pubKey.setOptions({ encryptionScheme: 'pkcs1' }); // 指定RSA加密协议，pkcs1 或 pkcs1_oaep，默认pkcs1_oaep
      const cryptStr = pubKey.encrypt(keyStr + ivStr, 'base64');

      return {
        key: key,
        iv: iv,
        'e-key': cryptStr,
        encry: encry ? encry.toString() : null
      }
    },
    // 解密返回数据
    decry4Aes(data, aes) {
      if (data.encry_str && aes) {
        const decrypt = CryptoJS.AES.decrypt(data.encry_str, aes.key, {
          iv: aes.iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedStr.toString());
      }
      return data;
    },
    httpCb(flag, response, options) {
      if (flag) {
        let json = response.data;

        if (json && json[types.KEY_STATUS]) {
          if (json[types.KEY_STATUS] >= 200) {
            if (json[types.KEY_STATUS] === types.CODE_SUCCESS) {
              // options.okcb && (options.okcb.call(this, json.obj, json.message));

              // 解密返回数据
              let obj = json.obj || null;
              if (obj) {
                obj = this.decry4Aes(obj, options.aes);
              }
              // console.log(obj)
              options.okcb && (options.okcb.call(this, obj, json.message));

              options.cb && (options.cb.call(this, json));
            } else {
              options.cb && (options.cb.call(this, json));
              options.errcb && (options.errcb.call(this, response.data));
              this.$message.error(json.message);
            }
          } else {
            options.cb && (options.cb.call(this, json));
          }
        } else {
          //options.okcb && (options.okcb.call(this, json));
          options.cb && (options.cb.call(this, json));
        }
      } else {
        options.cb && (options.cb.call(this, response.data));
        options.errcb && (options.errcb.call(this, response.data));
        response.data && this.$message.error(response.data);
      }
    },
    httpCb1(flag, response, options) {
      if (flag) {
        let json = response.body;

        if (json && json[types.KEY_STATUS]) {
          if (json[types.KEY_STATUS] >= 200) {
            if (json[types.KEY_STATUS] === types.CODE_SUCCESS) {
              options.okcb && (options.okcb.call(this, json.obj));
              options.cb && (options.cb.call(this, json));
            } else {
              options.cb && (options.cb.call(this, json));
              options.errcb && (options.errcb.call(this, response.body));
              this.$message.error(json.message);
            }
          } else {
            options.cb && (options.cb.call(this, json));
          }
        } else {
          //options.okcb && (options.okcb.call(this, json));
          options.cb && (options.cb.call(this, json));
        }
      } else {
        options.cb && (options.cb.call(this, response.body));
        options.errcb && (options.errcb.call(this, response.body));
        this.$message.error(response.body);
      }
    },
    doGet(options) {
      options.headers = Object.assign({}, this.headers);
      doGet(options);
      /*const request = (options) => {
        let data = options.data || {};

        // get 只提交已加密的AES密钥
        const aes = this.initAesKey(null);
        options.aes = aes;

        let url = options.url;
        if (!(url.startsWith('//') || url.startsWith('http'))) {
          url = this.rootPath + url;
        }

        this.$axios.get(url, {headers: Object.assign({}, this.headers, {'e-key': aes['e-key']}), params: data, withCredentials:true})
          .then((response) => {
            this.httpCb(true, response, options);
          })
          .catch((response) => {
            this.httpCb(false, response, options);
          });
      }

      if (!this.publickey) {
        this.$store.dispatch('publickey', {
          callback: () => {
            request(options);
          }
        })
      } else {
        request(options);
      }*/

      // get 只提交已加密的AES密钥
      // console.log('publickey0', this.publickey)
      // console.log('publickey1', this.$store.getters.publickey)

      // console.log('url', options.url, data)
      // const aes = this.initAesKey(null);
      // options.aes = aes;

      // let url = options.url;
      // if (!(url.startsWith('//') || url.startsWith('http'))) {
      //   url = this.rootPath + url;
      // }

      // request.get(url, {headers: Object.assign({}, this.headers, {'e-key': aes['e-key']}), params: data, withCredentials:true})
      //   .then((response) => {
      //     this.httpCb(true, response, options);
      //   })
      //   .catch((response) => {
      //     this.httpCb(false, response, options);
      //   });
    },
    // doGet1(options) {
    //   let data = options.data || {};
    //   this.$http.get(options.url, {params: data}).then((response) => {
    //     this.httpCb(true, response, options);
    //   }, (response) => {
    //     this.httpCb(false, response, options);
    //   });
    // },
    doPost(options) {
      options.headers = Object.assign({}, this.headers);
      doPost(options);
      // const request = (options) => {
      //   let data = options.data || {};
        
      //   // 生成AES密钥及向量
      //   const aes = this.initAesKey(data);
      //   options.aes = aes;
  
      //   let url = options.url;
      //   if (!(url.startsWith('//') || url.startsWith('http'))) {
      //     url = this.rootPath + url;
      //   }
  
      //   this.$axios.post(url, aes.encry, {headers: Object.assign({}, this.headers, {'Content-Type':'application/json', 'e-key': aes['e-key']}), withCredentials:true})
      //     .then((response) => {
      //       this.httpCb(true, response, options);
      //     })
      //     .catch((response) => {
      //       this.httpCb(false, response, options);
      //     });
      // }

      // if (!this.publickey) {
      //   this.$store.dispatch('publickey', {
      //     callback: () => {
      //       request(options);
      //     }
      //   })
      // } else {
      //   request(options);
      // }
    },
    doUpload4Vant(options) {
      if (!options.file) {
        console.error('未获取到上传参数：[file] ！');
        return;
      }
      /* eslint-disable no-undef */
      let param = new FormData();  // 创建form对象
      param.append('file', options.file);  // 通过append向form对象添加数据
      // 添加form表单中其他数据
      if (options.data) {
        Object.keys(options.data).forEach(key => {
          param.append(key, options.data[key]);
        });
      }
      // let config = Object.assign({}, this.header, {'Content-Type': 'multipart/form-data'});

      options.headers = Object.assign({}, this.headers);
      options.formData = param;
      options.contentType = 'multipart/form-data';
      options.timeout = 120000;

      doPost(options);

      // 添加请求头
      // this.$axios.post(options.url, param, config)
      //   .then(res => {
      //     this.uploadCb4Axios(res, options);
      //   })
      //   .catch((res) => {
      //     this.uploadCb4Axios(res, options);
      //   })
    },
    doUpload4ElUpload(options) {
      const formData = new FormData();

      if (options.data) {
        Object.keys(options.data).forEach(key => {
          formData.append(key, options.data[key]);
        });
      }
      formData.append(options.filename, options.file, options.file.name);

      options.url = options.action || 'sys/utils/uploadPic';
      options.formData = formData;
      options.headers = Object.assign({}, this.headers);
      options.contentType = 'multipart/form-data';
      options.onUploadProgress = (e) => {
        if (e.total > 0) {
          e.percent = e.loaded / e.total * 100;
        }
        options.onProgress(e);
      };
      options.timeout = 120000;

      doPost(options);
    },
    doDownload(options) {
      options.downLoading = true;
      let success = (response) => {
        let filename = response.headers['x-filename'];
        if (filename) {
          filename = decodeURIComponent(filename);
          filename = filename.replace(/%20/g, ' ');
          fileDownload(response.data, filename);
        } else {
          const self = this;
          const reader = new FileReader();
          reader.readAsText(response.data, 'utf-8');
          reader.onload = () => {
            let json = JSON.parse(reader.result);
            if (json && json.message) {
              if (json.status == 200) {
                self.$message.warning(json.message);
              } else {
                self.$message.error(json.message);
              }
            }
          }
        }
        if (options.cb) {
          options.cb();
        }
        options.downLoading = false;
      };
      let fail = (response) => {
        options.downLoading = false;
        this.$message.error(response.message || '下载失败，远程服务器错误！');
        options.cb();
      };
      if (!options.type) {
        options.type = 'get';
      }
      // responseType 设为blob，后台返回出错json信息时，方便解析
      const responseType = 'blob'; // arraybuffer
      if (options.type.toLowerCase == 'get') {
        doGet({
          url: options.url,
          headers: Object.assign({}, this.headers),
          responseType: responseType,
          data: options.data || {},
          success: success,
          fail: fail
        });
        /*
        this.$axios.get(url, {headers: this.headers, responseType: responseType, params: options.data || {}})
          .then((response) => {
            success(response);
          })
          .catch((response) => {
            fail(response);
          });
        */
      } else {
        doPost({
          url: options.url,
          data: options.data || {},
          headers: Object.assign({}, this.headers),
          responseType: responseType,
          success: success,
          fail: fail
        })
        // this.$axios.post(url, options.data || {}, {headers: this.headers, responseType: responseType})
        //   .then((response) => {
        //     success(response);
        //   })
        //   .catch((response) => {
        //     fail(response);
        //   });
      }
    },
    // doPost1(options) {
    //   let data = options.data || {};
    //   this.$http.post(options.url, data).then((response) => {
    //     this.httpCb(true, response, options);
    //   }, (response) => {
    //     this.httpCb(false, response, options);
    //   });
    // },
    // 性别
    showSex(sex) {
      if (sex === null || sex === undefined) {
        return '';
      }
      return this.sexMap[sex] ? this.sexMap[sex].name : sex;
    },
    // 校区
    showXiaoqu(xqid, fullname) {
      if (xqid === null || xqid === undefined) {
        return '';
      }
      return fullname ? ((this.xiaoquMap[xqid])?.name ?? xqid) : ((this.xiaoquMap[xqid])?.shortname ?? xqid);
    },
    // namepath，将逗号分隔换成斜杠
    namepath(str) {
      return str ? str.replace(/,/g, ' / ') : str;
    },
    // 显示金额（int to float)
    showPrice(price, showzero = true) {
      return price ? price / 100 : (showzero ? 0 : null);
    },
    // 格式化日期
    formatDate(date, fmt = 'yyyy-MM-dd') {
      if (!date) {
        return date;
      }
      // console.log(date)
      let _date = date;
      if (!(_date instanceof Date)) {
        if (typeof _date === 'string') {
          _date = _date.toDate();
        } else if (typeof _date === 'number') {
          _date = new Date(_date);
        }
      }
      if (!(_date instanceof Date)) {
        return date;
      }
      return formatDate(_date, fmt);
    },
    // 设置背景图片
    bgImg(path) {
      let baseurl = path.startsWith('//') || path.startsWith('http') ? '' : `${this.assetsPath}static/images/`;
      return {'background-image': `url(${baseurl}${path})`};
    },
    // 图片本地地址
    imgLocal(img) {
      if (!img) {
        return img;
      }
      return img.startsWith('//') || img.startsWith('http') ? img : `${this.assetsPath}static/images/${img}`;
    },
    // 图片地址
    imgPath(img) {
      if (!img) {
        return img;
      }
      return img.startsWith('//') || img.startsWith('http') || img.startsWith('/') || img.startsWith('data:') ? img : `${this.rootPath}${img}`;
    },
    // 检查权限
    hasPermiss(permiss) {
      return this.userinfo.permissions.indexOf(permiss) > -1;
    },
    // 判断是否本公司
    isSelfCompany(companyid) {
      return companyid == this.userinfo.companyid;
    },
    // 确认提示
    msgbox(msg, okcb, options) {
      options = options || {};
      this.$confirm(msg, options.title || '提示', {
        confirmButtonText: options.confirmButtonText || '确定',
        cancelButtonText: options.cancelButtonText || '取消',
        type: options.type || 'warning'
      }).then(() => {
        okcb && okcb.apply();
      }).catch(() => {
        options.cancelcb && options.cancelcb.apply();
      });
    },
    // 提示保存
    confirmSave(msg, done, cancel) {
      // 判断是否需要保存
      if (JSON.stringify(this.editData) !== this.originData) {
        this.msgbox(
          msg || '未保存编辑数据，离开可能会丢失数据，【确定】吗？',
          () => {
            this.leaveData = JSON.stringify(this.editData); // 暂存数据
            done();
            let obj = JSON.parse(this.originData);
            for (let key of Object.keys(obj)) {
              this.editData[key] = obj[key];
            }
          },
          {
            cancelcb: cancel
          }
        )
      } else {
        done();
      }
    },
    // 保存原始editData
    setOriaData(delay, cb) {
      setTimeout(() => {
        this.leaveData = ''; // 清除暂存数据
        this.originData = JSON.stringify(this.editData);
        if (cb)
          cb();
      }, delay !== undefined ? delay : 500);
    },
    // 清除jy.grid
    clearGridData(data) {
      let delGrid = (_data) => {
        Object.keys(_data).forEach(k => {
          if (k.startsWith('jy.grid')) {
            delete _data[k];
          }
        });
      };
      Array.isArray(data)
        ? data.forEach(_d => { delGrid(_d) })
        : delGrid(data);
    },
    // card模式，hover
    enterCard(ishover, $e) {
      let _class = 'border-danger';
      let target = $e.target;
      if (ishover) {
        addClass(target, _class);
      } else {
        removeClass(target, _class);
      }
    },
    // 滚动到指定ref
    scroll2Ref(ref, scrollContainer) {
      let $ref = this.$refs[ref];
      if ($ref) {
        let offsetTop = getAbsPoint($ref.$el).y;
        scrollContainer.scrollTop = offsetTop;
      }
    },
    // 打开帮助窗口
    doHelp(navname) {
      ///help-view/'+ (navname || '')
      window.open(this.BASEPATH +'/help/#/help-view/'+ navname, '_blank', 'top=100,left=100,width=600,height=400,menubar=no,location=no,scrollbars=yes,toolbar=no,status=no');
      //window.open(this.rootPath + 'sys/help/content/getByNavname', '_blank', 'top=100,left=100,width=500,height=400,menubar=no,scrollbars=no,toolbar=no,status=no');
    },
    triggerActivated() {
      // console.log('trigger.......')
      /* eslint-disable */
      this.$emit('jy.activated');
      this.broadcast('JyPagebody', 'jy.activated', []);
      this.broadcast('JyDialog', 'jy.activated', []);
    }
  },
  activated () {
    this.initUI();
    // console.log('...activated...')
    /* eslint-disable */
    this.$emit('jy.activated');

    this.broadcast('JyPagebody', 'jy.activated', []);
    //this.broadcast('JyDialog', 'jy.activated', []);
    this.broadcast('JyField', 'jy.field.validate', [true]);

    if (!this.xiaoquMap || !Object.keys(this.xiaoquMap).length) {
      this.$store.dispatch(types.BASE_LOAD.xiaoquList);
    }
  },
  deactivated () {
    this.broadcast('JyPagebody', 'jy.deactivated', []);
    this.broadcast('JyDialog', 'jy.deactivated', []);
    this.broadcast('JyField', 'jy.field.validate', [false]);
  },
  destroyed () {
    this.broadcast('JyField', 'jy.field.validate', [false]);
  }
}
